<template>
  <div>
    <div class="center" v-if="showLoading">
		  <lottie :options="defaultOptionsSplashScreen" :height="300" :width="300" v-on:animCreated="handleAnimationSplashScreen"/>
	  </div>
    <div v-else>
      <headerSection></headerSection>
      <div id="main__content" class="huay-page">
        <div class="x-main-container">
          <div class="x-main-content">
            <!-- Hero Section -->
            <div class="hero-section">
              <div class="floating-ball ball-1"></div>
              <div class="floating-ball ball-2"></div>
              <div class="floating-ball ball-3"></div>

              <div class="hero-content">
                <div class="dice-icon-wrapper">
                  <span class="dice-icon">🎲</span>
                </div>
                <h1 class="title-glow">{{ $t('huay_page.title') }}</h1>
                <div class="quota-display">
                  <span class="quota-text">{{ $t('huay_page.title2') }}</span>
                  <div class="quota-badge">
                    <span class="quota-count">{{countQTY}}</span>
                    <span class="quota-separator">/</span>
                    <span class="quota-total">{{QTY}}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Number Selection Grid -->
            <div class="lottery-container">
              <div class="selection-info">
                <div class="info-card">
                  <span class="info-icon">👆</span>
                  <span class="info-text">เลือกหมายเลขที่คุณต้องการ</span>
                </div>
              </div>

              <!-- Confirm Button Top -->
              <div class="button-wrapper" v-if="isShow">
                <button
                  type="button"
                  @click="confirm()"
                  :disabled="isDisabled"
                  class="confirm-btn"
                  :class="{ 'disabled': isDisabled }"
                >
                  <span class="btn-text">{{this.buttonLabel}}</span>
                  <span class="btn-shine"></span>
                </button>
              </div>

              <!-- Number Grid -->
              <div class="number-grid">
                <div
                  class="number-ball"
                  :class="{ 'selected': huays[renderNumber(index,col)] }"
                  v-for="index in rows"
                  :key="`row-${index}`"
                >
                  <template v-for="col in 5">
                    <div
                      :key="`${index}-${col-1}`"
                      class="ball-item"
                      :class="{ 'active': huays[renderNumber(index,col-1)] }"
                      @click="selectNumber(renderNumber(index,col-1))"
                    >
                      <div class="ball-inner">
                        <span class="ball-number">{{renderNumber(index,col-1)}}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>

              <!-- Confirm Button Bottom -->
              <div class="button-wrapper" v-if="isShow">
                <button
                  type="button"
                  @click="confirm()"
                  :disabled="isDisabled"
                  class="confirm-btn"
                  :class="{ 'disabled': isDisabled }"
                >
                  <span class="btn-text">{{this.buttonLabel}}</span>
                  <span class="btn-shine"></span>
                </button>
              </div>

              <!-- Description -->
              <div class="description-card">
                <p class="description-text">{{ $t('huay_page.description') }}</p>
              </div>
            </div>

            <footerSection></footerSection>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase, { database } from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import _ from 'lodash'
import router from './../router'
import Lottie from './lottie.vue'
import * as animateSantaWalk from '../assets/loading.json'
import moment from 'moment-timezone'
const axios = require('axios').default
require('vue2-animate/dist/vue2-animate.min.css')
// @ is an alias to /src
export default {
  name: 'Gift',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    lottie: Lottie
  },
  created () {
    const user = localStorage.getItem('userData')
    if (user) {
        const _user = JSON.parse(user)
        this.$store.dispatch('user/setUser', _user).then(async()=>{
          const huay = (await firebase.database().ref('/huay').once('value')).val()
          const dateHuay = [];
          for(const x in huay){
            dateHuay.push(Number(huay[x]))
          }
          if(dateHuay.includes(Number(moment().tz("Asia/Bangkok").format('D')))){
              if(Number(moment().tz("Asia/Bangkok").format('H')+''+moment().tz("Asia/Bangkok").format('mm')) <= 1520){
                this.calculate();
                this.isShow = true;
              }else{
                 this.calculate();
              }
            }else{
              this.QTY = 0;
              this.countQTY = 0;
            }
        }).catch(err => { console.error(err) })
    } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
    }
    const animateSplashScreen = animateSantaWalk.default
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  mounted () {
        this.buttonLabel = this.$t('huay_page.confirm_bet')
        this.animSplashScreen.play()
        setTimeout(() => {
            this.showLoading = false
            this.animSplashScreen.stop()
            // setTimeout(() => {
            //   this.canvas = document.getElementById('canvas')
            //   this.repaint(this.angle)
            // }, 500)
        }, 3500)
      //this.getGames()
  },
  data () {
    return {
      isShow: false,
      huays:[],
      rows:20,
      logoLeft: '',
      logoRight: '',
      angle: 0,
      gameKey: 'spin',
      showLoading: true,
      pictureUrl: '',
      code: '',
      games_web: [],
      search: '',
      loading: false,
      error: false,
      web: [],
      message: 'Invalid user name or password!',
      point: 0,
      favorites: [],
      animationInfinite: {
        classes: 'fadeIn',
        duration: 5000,
        iteration: 'infinite'
      },
      buttonLabel: '',
      permission: [],
      defaultOptions: null,
      defaultOptions2: null,
      defaultOptionsSplashScreen: null,
      openGiftData: false,
      canOpen: false,
      percentage: 0,
      loadingtext: '',
      credit: '',
      save: false,
      canvas: null,
      frame: null,
      wheels: null,
      sections: [],
      sectionspoint: [],
      colors: [],
      percent: [],
      isDisabled: false,
      QTY:'loading',
      countQTY:'loading',
    }
  },
  methods: {
    calculate(){
        firebase.firestore().collection('krungsri').where('date', '>=', moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 00:00:00').where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('userkey','==',this.user.key).get().then((snapshot)=>{
            let deposit = 0;
            snapshot.forEach((doc)=>{
                deposit += (Number(doc.data().qty.toString().replace(',','')));
            });
            const qty = Math.floor(deposit/200);
            this.QTY = (qty>10)?10:qty;
            if(qty){
            firebase.firestore().collection('huays').doc(this.user.key+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then((doc)=>{
                if(doc.exists){
                    if(doc.data().huays){
                        for(const x in doc.data().huays){
                            const xx = doc.data().huays[x];
                            this.huays[xx] = true;
                        }
                        this.countQTY = doc.data().huays.length;
                    }
                }else{
                    this.countQTY = 0;
                }
            });
            }
    });
    },
    selectNumber(num){
        if(typeof this.countQTY == 'number' && typeof this.QTY == 'number' && this.isShow){
            if(this.huays[num]){
                delete this.huays[num]
                this.countQTY--
            }else if(this.QTY > this.countQTY){
                this.huays[num] = true
                this.countQTY++
            }
            this.rows++;
            this.rows--;
        }
    },
    async confirm() {
        if(Object.keys(this.huays).length <= this.QTY && this.QTY > 0){
            this.buttonLabel = 'loading...';
            this.isDisabled = true;
            const huays = [];
            let lotto = '';
            for(const x in this.huays){
                if(this.huays[x]){
                    huays.push(x);
                    lotto += (lotto)?', '+x:x;
                }
            }
            firebase.firestore().collection('huays').doc(this.user.key+'-'+moment().tz("Asia/Bangkok").format('YYYY-MM-DD')).set({
                huays,
                userkey: this.user.key,
                updatetime: moment().tz("Asia/Bangkok").format('YYYY-MM-DD HH:mm:ss'),
                date: moment().tz("Asia/Bangkok").format('YYYY-MM-DD'),
                code:this.user.code,
            }).then(async ()=>{
                this.isDisabled = false;
                this.buttonLabel = this.$t('huay_page.confirm_bet');
                this.$confirm(
                    {
                        message: this.$t('huay_page.bet_success'),
                        button: {
                            yes: 'OK'
                        },
                        callback: confirm => {
                        if (confirm) {

                            // this.getUserId()
                        }
                        }
                    }
                )
            });
        }else{
          alert(this.$t('huay_page.check_bet_rights'));
        }
    },
    renderNumber(row,i){
        const num = ((row-1)*5)+i;
        if(num.toString().length == 1){
            return '0'+num;
        }else{
            return num.toString();
        }
    },
    handleAnimationSplashScreen: function (anim) {
      this.animSplashScreen = anim
    },
    async getGames () {
      this.games_web = (await firebase.database().ref('/spin').once('value')).val()
    },
    checkCssBox (game) {
      if (!game.status) {
        return 'box-shadow: 0 0 12px 5px #cccccc;border: 2px solid #cccccc;'
      }
    },
    checkCss (game) {
      if (!this.permission || !this.permission[game.key]) {
        return 'filter: grayscale(100%);'
      }
      // const index = _.findIndex(this.favorites, function(o) { return o == code; });
      // if (index>-1) {
      //   return '';
      // } else {
      //   return 'filter: grayscale(100%);';
      // }
    },
    goto (type) {
      if (type === 'home') {
        // window.scrollTo({
        //   top: 0,
        //   left: 0,
        //   behavior: 'smooth'
        // });
        this.$router.push('/').catch(() => {})
      } else if (type === 'website') {
        window.location = this.web.link
        // this.gotoline()
      } else if (type === 'contact') {
        window.location = this.web.link_line
        // this.gotoline()
      }
    },
  }
}
</script>

<style scoped>
/* ===== Loading Screen ===== */
.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* ===== Page Base ===== */
.huay-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1b1b41 0%, #492666 50%, #2b2727 100%);
  padding-bottom: 100px;
}

/* ===== Hero Section ===== */
.hero-section {
  position: relative;
  padding: 40px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(131, 9, 162, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 10;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ===== Dice Icon ===== */
.dice-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: roll 3s ease-in-out infinite;
}

.dice-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(255, 193, 7, 0.4));
}

@keyframes roll {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
}

/* ===== Floating Balls ===== */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #8309a2, #ffc107);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #fe8a02, #ffc107);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #492666, #8309a2);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(25px, -25px) rotate(180deg); }
}

/* ===== Title ===== */
.title-glow {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  background: linear-gradient(135deg, #ce93d8, #8309a2, #ce93d8);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: purpleShine 3s linear infinite;
}

@keyframes purpleShine {
  to {
    background-position: 200% center;
  }
}

/* ===== Quota Display ===== */
.quota-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.quota-text {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
}

.quota-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(145deg, rgba(255, 193, 7, 0.15), rgba(255, 193, 7, 0.05));
  border: 2px solid rgba(255, 193, 7, 0.3);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  font-size: 24px;
  font-weight: 700;
}

.quota-count {
  color: #ffc107;
}

.quota-separator {
  color: rgba(255, 255, 255, 0.5);
}

.quota-total {
  color: rgba(255, 255, 255, 0.8);
}

/* ===== Lottery Container ===== */
.lottery-container {
  max-width: 800px;
  margin: 30px auto 0;
  padding: 0 20px;
}

/* ===== Selection Info ===== */
.selection-info {
  margin-bottom: 25px;
  text-align: center;
}

.info-card {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(131, 9, 162, 0.3);
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.info-icon {
  font-size: 24px;
}

.info-text {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

/* ===== Number Grid ===== */
.number-grid {
  display: grid;
  gap: 15px;
  margin: 25px 0;
}

.number-ball {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}

.ball-item {
  aspect-ratio: 1;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
}

.ball-inner {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  border: 2px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.ball-number {
  font-size: 20px;
  font-weight: 700;
  color: white;
  z-index: 2;
  transition: all 0.3s ease;
}

/* Ball Hover Effect */
.ball-item:hover .ball-inner {
  transform: scale(1.1);
  border-color: rgba(131, 9, 162, 0.5);
  box-shadow: 0 4px 20px rgba(131, 9, 162, 0.4);
}

/* Active/Selected Ball */
.ball-item.active .ball-inner {
  background: linear-gradient(135deg, #ffc107, #fe8a02);
  border-color: #ffc107;
  box-shadow: 0 0 20px rgba(255, 193, 7, 0.6), 0 0 40px rgba(255, 193, 7, 0.3);
  animation: pulseGold 1.5s ease-in-out infinite;
}

.ball-item.active .ball-number {
  color: #1b1b41;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

@keyframes pulseGold {
  0%, 100% {
    box-shadow: 0 0 20px rgba(255, 193, 7, 0.6), 0 0 40px rgba(255, 193, 7, 0.3);
  }
  50% {
    box-shadow: 0 0 30px rgba(255, 193, 7, 0.8), 0 0 60px rgba(255, 193, 7, 0.5);
  }
}

/* ===== Confirm Button ===== */
.button-wrapper {
  margin: 25px 0;
  text-align: center;
}

.confirm-btn {
  position: relative;
  padding: 16px 48px;
  font-size: 18px;
  font-weight: 700;
  color: white;
  background: linear-gradient(135deg, #8309a2 0%, #492666 100%);
  border: none;
  border-radius: 30px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(131, 9, 162, 0.4), 0 0 30px rgba(131, 9, 162, 0.2);
  min-width: 200px;
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(131, 9, 162, 0.6), 0 0 40px rgba(131, 9, 162, 0.3);
}

.confirm-btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: linear-gradient(135deg, #666 0%, #444 100%);
}

.confirm-btn.disabled:hover {
  transform: none;
  box-shadow: 0 4px 15px rgba(131, 9, 162, 0.4);
}

.btn-text {
  position: relative;
  z-index: 2;
}

.btn-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: shine 3s ease-in-out infinite;
  z-index: 1;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  50%, 100% {
    left: 100%;
  }
}

/* ===== Description Card ===== */
.description-card {
  margin-top: 30px;
  padding: 20px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(131, 9, 162, 0.3);
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.description-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin: 0;
  text-align: center;
}

/* ===== Responsive ===== */
@media screen and (max-width: 768px) {
  .title-glow {
    font-size: 28px;
  }

  .dice-icon {
    font-size: 48px;
  }

  .quota-badge {
    font-size: 20px;
    padding: 10px 20px;
  }

  .number-ball {
    gap: 10px;
  }

  .ball-number {
    font-size: 18px;
  }

  .confirm-btn {
    font-size: 16px;
    padding: 14px 40px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 30px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .dice-icon {
    font-size: 40px;
  }

  .quota-text {
    font-size: 14px;
  }

  .quota-badge {
    font-size: 18px;
    padding: 8px 16px;
  }

  .number-ball {
    gap: 8px;
  }

  .ball-number {
    font-size: 16px;
  }

  .ball-inner {
    border-width: 1.5px;
  }

  .confirm-btn {
    font-size: 15px;
    padding: 12px 32px;
    min-width: 180px;
  }

  .info-card {
    padding: 10px 20px;
  }

  .info-icon {
    font-size: 20px;
  }

  .info-text {
    font-size: 14px;
  }

  .description-card {
    padding: 15px;
  }

  .description-text {
    font-size: 13px;
  }
}

/* ===== Legacy Styles ===== */
.glow {
  color: #fff;
  text-align: center;
  -webkit-animation: glow 1s ease-in-out infinite alternate;
  -moz-animation: glow 1s ease-in-out infinite alternate;
  animation: glow 1s ease-in-out infinite alternate;
}

@-webkit-keyframes glow {
  from {
    text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
  }
  to {
    text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
  }
}
</style>
